import React from 'react';
import queryString from 'query-string';
import './index.scss';
import { useLocation, Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import logo from './../../../assets/images/logo.svg';
import logopt from './../../../assets/images/logo-pt.svg';

import { DEFAULT_LOCALE } from '../../../constants/index';

const Header = (props) => {
    const configuration = useSelector((state) => state.configuration);

    const { content } = configuration || {};
    const logoTranslation = content?.content?.labels?.sections[0]?.translations[0];

    const { search } = useLocation();
    let params = queryString.parse(search);

    const { locale } = params || {};

    const defaultUrl = locale ? locale : DEFAULT_LOCALE;
    const isPT = defaultUrl === 'pt_PT';
    const currentLogo = isPT ? logopt : logo;

    return (
        <header className={`header ${props.isMainLayout && 'main-layout'}`}>
            <div className="header__container container">
                <Link role="banner" tabIndex='1' to={`/?locale=${defaultUrl}`} alt={logoTranslation?.text || 'Prepara tu Próxima Consulta'}>
                    <span className="logo lazy-load-image-background lazy-load-image-loaded" style={{ display: 'inline-block' }}>
                        <img 
                            aria-label={logoTranslation?.text || 'Prepara tu Próxima Consulta'}
                            alt={logoTranslation?.text || 'Prepara tu Próxima Consulta'} 
                            src={currentLogo}
                        />
                    </span>
                </Link>
            </div>
        </header>
    );    
};

export default Header;
